export default __webpack_public_path__ + "notfound_inv.png";